export const LABEL_CFG_KEY       = 'phonelab_label_config';
export const REPAIR_DEFAULTS_KEY = 'phonelab_repair_defaults';
export const SALE_DEFAULTS_KEY   = 'phonelab_sale_defaults';

export const fmtPrice = (n) =>
  n == null || isNaN(n) ? '—' : Number(n).toFixed(2).replace('.', ',');

// ── Définitions par défaut des champs pour l'éditeur drag-and-drop ───────────
export const SALE_FIELD_DEFS = [
  { key: 'name',      label: 'Nom produit',  x: 2,  y: 3,  fontSize: 12, fontWeight: 900 },
  { key: 'storage',   label: 'Stockage',     x: 2,  y: 24, fontSize: 9,  fontWeight: 700 },
  { key: 'price',     label: 'Prix',         x: 53, y: 19, fontSize: 18, fontWeight: 900 },
  { key: 'condition', label: 'État',         x: 2,  y: 38, fontSize: 8,  fontWeight: 400 },
  { key: 'battery',   label: 'Batterie',     x: 2,  y: 51, fontSize: 8,  fontWeight: 400 },
  { key: 'origin',    label: 'Origine',      x: 2,  y: 63, fontSize: 8,  fontWeight: 400 },
  { key: 'payment',   label: 'Paiement',     x: 2,  y: 77, fontSize: 9,  fontWeight: 700 },
];

export const REPAIR_FIELD_DEFS = [
  { key: 'repairNum',   label: 'N° Ticket',   x: 2,  y: 2,  fontSize: 8,  fontWeight: 700 },
  { key: 'date',        label: 'Date',         x: 66, y: 2,  fontSize: 7,  fontWeight: 400 },
  { key: 'clientName',  label: 'Nom client',   x: 2,  y: 18, fontSize: 9,  fontWeight: 700 },
  { key: 'clientPhone', label: 'Téléphone',    x: 2,  y: 32, fontSize: 13, fontWeight: 700 },
  { key: 'device',      label: 'Panne',        x: 2,  y: 57, fontSize: 7,  fontWeight: 400 },
  { key: 'price',       label: 'Prix TTC',     x: 2,  y: 73, fontSize: 11, fontWeight: 700 },
  { key: 'pin',         label: 'Code PIN',     x: 64, y: 73, fontSize: 8,  fontWeight: 700 },
];

// ── Génère le HTML depuis un tableau de champs positionnés ───────────────────
export function buildFromFields(fields, labelWidth, labelHeight) {
  const html = fields
    .filter(f => f.show !== false && f.text && f.text.trim())
    .map(f => {
      const pinStyle = f.key === 'pin'
        ? 'border:.5pt solid #000;padding:0 1mm;border-radius:.5mm;'
        : '';
      return `<div style="position:absolute;left:${f.x.toFixed(1)}%;top:${f.y.toFixed(1)}%;font-size:${f.fontSize}pt;font-weight:${f.fontWeight || 400};text-decoration:${f.textDecoration || 'none'};font-family:Arial,'Arial Narrow',sans-serif;white-space:nowrap;color:#000;${pinStyle}">${f.text}</div>`;
    }).join('\n');
  return `<!DOCTYPE html><html lang="fr"><head><meta charset="utf-8"><title>Étiquette</title><style>*{box-sizing:border-box;margin:0;padding:0}@media print{@page{size:${labelWidth}mm ${labelHeight}mm;margin:0}html,body{width:${labelWidth}mm;height:${labelHeight}mm;overflow:hidden}}html,body{width:${labelWidth}mm;height:${labelHeight}mm;background:#fff;position:relative;overflow:hidden}</style></head><body style="position:relative">${html}</body></html>`;
}

// ── Étiquette RÉPARATION ─────────────────────────────────────────────────────
export function buildLabelHTML({
  brand = '', model = '', part = '', notes = '',
  clientName = '', clientPhone = '', repairNum = '', pinCode = '',
  priceTTC, labelWidth = 50, labelHeight = 30,
  fontSizes = {}, showFields = {},
}) {
  const today   = new Date();
  const dateStr = `${String(today.getDate()).padStart(2,'0')}/${String(today.getMonth()+1).padStart(2,'0')}/${String(today.getFullYear()).slice(-2)}`;

  const cfg        = readLabelCfg();
  const fs         = { ...cfg.fontSizes,  ...fontSizes  };
  const sh         = { ...cfg.showFields, ...showFields };
  const get        = (k, d) => fs[k] != null ? fs[k] : d;
  const show       = (k)    => sh[k]  != null ? sh[k]  : true;
  const productLine = [brand, model, notes || part].filter(Boolean).join(' · ');

  return `<!DOCTYPE html>
<html lang="fr"><head><meta charset="utf-8"><title>Étiquette réparation</title>
<style>
* { box-sizing:border-box;margin:0;padding:0 }
@media print { @page { size:${labelWidth}mm ${labelHeight}mm;margin:0 } html,body{width:${labelWidth}mm;height:${labelHeight}mm;overflow:hidden} }
html,body{font-family:Arial,'Arial Narrow',sans-serif;width:${labelWidth}mm;height:${labelHeight}mm;background:#fff;color:#000;overflow:hidden}
.wrap{padding:1mm 1.5mm;display:flex;flex-direction:column;height:100%;gap:0}
.row{display:flex;justify-content:space-between;align-items:flex-start}
.pin{border:.5pt solid #000;padding:0 1mm;border-radius:.5mm}
.trunc{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
</style></head>
<body><div class="wrap">
${(show('numTicket') || show('date')) ? `<div class="row">
  ${show('numTicket') && repairNum ? `<span style="font-size:${get('numTicket',20)}px;font-weight:700">#${repairNum}</span>` : '<span></span>'}
  ${show('date') ? `<span style="font-size:${get('date',12)}px;color:#555">${dateStr}</span>` : ''}
</div>` : ''}
${show('nomClient') && clientName ? `<div class="trunc" style="font-size:${get('nomClient',16)}px;font-weight:700">${clientName}</div>` : ''}
${show('telephone') && clientPhone ? `<div style="font-size:${get('telephone',28)}px;font-weight:700;letter-spacing:.5px">${clientPhone}</div>` : ''}
${show('panne') && productLine ? `<div class="trunc" style="font-size:${get('panne',16)}px;color:#333">${productLine}</div>` : ''}
<div class="row" style="margin-top:auto">
  ${show('prix') && priceTTC ? `<span style="font-size:${get('prix',24)}px;font-weight:700">${fmtPrice(priceTTC)}€</span>` : '<span></span>'}
  ${show('pinCode') && pinCode ? `<span class="pin" style="font-size:${get('pinCode',14)}px;font-weight:700">${pinCode}</span>` : ''}
</div>
</div></body></html>`;
}

// ── Étiquette VENTE produit ──────────────────────────────────────────────────
export function buildSaleLabelHTML({
  brand = '', model = '', storage = '', saleCondition = '',
  batteryPct = '', paymentText = '', originText = '', priceTTC,
  labelWidth = 50, labelHeight = 40,
  fontSizes = {}, showFields = {},
}) {
  const sc   = labelWidth / 50;
  const get  = (k, d) => fontSizes[`s_${k}`] != null ? fontSizes[`s_${k}`] : Math.round(d * sc);
  const show = (k)    => showFields[`s_${k}`] != null ? showFields[`s_${k}`] : true;

  const productName = [brand, model].filter(Boolean).join(' ');
  const price       = priceTTC ? fmtPrice(priceTTC) : '—';

  return `<!DOCTYPE html>
<html lang="fr"><head><meta charset="utf-8"><title>Étiquette vente</title>
<style>
* { box-sizing:border-box;margin:0;padding:0 }
@media print { @page { size:${labelWidth}mm ${labelHeight}mm;margin:0 } html,body{width:${labelWidth}mm;height:${labelHeight}mm;overflow:hidden} }
html,body{font-family:Arial,'Arial Narrow',sans-serif;width:${labelWidth}mm;height:${labelHeight}mm;background:#fff;color:#000;overflow:hidden}
.wrap{padding:1.5mm 2mm;display:flex;flex-direction:column;height:100%;gap:.4mm}
.top{display:flex;justify-content:space-between;align-items:baseline;gap:1mm}
.trunc{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
</style></head>
<body><div class="wrap">
<div class="top">
  ${show('name') ? `<span class="trunc" style="font-size:${get('name',10)}pt;font-weight:900;line-height:1;flex:1;min-width:0">${productName || 'Produit'}</span>` : '<span></span>'}
  ${show('price') ? `<span style="font-size:${get('price',17)}pt;font-weight:900;line-height:1;white-space:nowrap;flex-shrink:0">${price}€</span>` : ''}
</div>
${show('storage') && storage ? `<div style="font-size:${get('storage',8)}pt;font-weight:700">${storage}</div>` : ''}
${show('condition') && saleCondition ? `<div style="font-size:${get('condition',7)}pt">État: ${saleCondition}</div>` : ''}
${show('battery') && batteryPct ? `<div style="font-size:${get('battery',7)}pt">Batterie : ${batteryPct}%</div>` : ''}
${show('origin') && originText ? `<div style="font-size:${get('origin',7)}pt">${originText}</div>` : ''}
${show('payment') && paymentText ? `<div style="font-size:${get('payment',9)}pt;font-weight:900;margin-top:auto">${paymentText}</div>` : ''}
</div></body></html>`;
}

// ── helpers ──────────────────────────────────────────────────────────────────
export function readLabelCfg() {
  try {
    const s = JSON.parse(localStorage.getItem(LABEL_CFG_KEY));
    return {
      labelWidth:  s?.labelWidth  ?? 50,
      labelHeight: s?.labelHeight ?? 30,
      fontSizes:   s?.fontSizes   ?? {},
      showFields:  s?.showFields  ?? {},
      labelPrinter:    s?.labelPrinter    ?? 'Clabel-CT221B',
      useLabelPrinter: s?.useLabelPrinter ?? false,
    };
  } catch { return { labelWidth: 50, labelHeight: 30, fontSizes: {}, showFields: {}, labelPrinter: '', useLabelPrinter: false }; }
}

export async function sendToQZ(printerName, html) {
  if (!window.qz?.websocket?.isActive()) {
    await window.qz.websocket.connect({ retries: 3, delay: 1 });
  }
  const cfg = window.qz.configs.create(printerName, { colorType: 'blackwhite', copies: 1 });
  await window.qz.print(cfg, [{ type: 'html', format: 'plain', data: html }]);
}

// ── Ticket POS pour impression depuis le Catalogue ───────────────────────────
export function buildCatalogTicketHTML({ brand = '', model = '', part = '', quality = '', price, width = 80 }) {
  const today = new Date();
  const dateStr = `${String(today.getDate()).padStart(2,'0')}/${String(today.getMonth()+1).padStart(2,'0')}/${today.getFullYear()}`;
  const priceStr = price != null && !isNaN(price) ? `${Number(price).toFixed(2).replace('.', ',')} €` : '';
  const productLine = [brand, model].filter(Boolean).join(' ');

  return `<!DOCTYPE html><html lang="fr"><head><meta charset="utf-8"><title>Ticket PhoneLab 69</title><style>
*{box-sizing:border-box;margin:0;padding:0}
@media print{@page{size:${width}mm auto;margin:2mm 3mm}html,body{width:${width}mm}}
html,body{font-family:'Courier New',monospace;font-size:10px;width:${width}mm;background:white;color:black}
.center{text-align:center}.bold{font-weight:700}.big{font-size:14px}.line{border-top:1px dashed #000;margin:5px 0}
.row{display:flex;justify-content:space-between;padding:1px 0}.small{font-size:8px}
</style></head><body>
<div class="center bold big">PhoneLab 69</div>
<div class="center small" style="color:#555;margin-bottom:4px">${dateStr}</div>
<div class="line"></div>
${productLine ? `<div class="bold" style="font-size:11px">${productLine}</div>` : ''}
${part ? `<div style="color:#444">${part}</div>` : ''}
${quality ? `<div class="small" style="color:#555">${quality}</div>` : ''}
<div class="line"></div>
${priceStr ? `<div class="center bold" style="font-size:16px;margin:6px 0">${priceStr}</div>` : ''}
<div class="line"></div>
<div class="center small" style="margin-top:4px">Merci de votre visite !</div>
</body></html>`;
}

// ── Impression ticket POS depuis le Catalogue (QZ Tray ou fallback navigateur) ─
export async function printCatalogPOS({ brand, model, part, quality, price }) {
  const html = buildCatalogTicketHTML({ brand, model, part, quality, price });
  let cfg = null;
  try { cfg = JSON.parse(localStorage.getItem('phonelab_print_config')); } catch {}

  if (cfg?.useQZ && cfg?.printer && typeof window.qz !== 'undefined') {
    try {
      if (!window.qz.websocket.isActive()) await window.qz.websocket.connect({ retries: 3, delay: 1 });
      const qzCfg = window.qz.configs.create(cfg.printer, { colorType: 'blackwhite', copies: 1 });
      await window.qz.print(qzCfg, [{ type: 'html', format: 'plain', data: html }]);
      return;
    } catch {}
  }

  // Fallback navigateur
  const w = window.open('', '_blank', 'width=400,height=600,toolbar=0,menubar=0,scrollbars=1');
  if (w) { w.document.write(html); w.document.close(); setTimeout(() => { w.focus(); w.print(); }, 400); }
}
